module.exports = __webpack_public_path__ + "assets/04917b0f9ce1f67f70768369d2b6bd2f.json";